/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Select_Next_EventInputs */



/**
* | output |
* | --- |
* | "Select Next Event" |
*
* @param {Shortcut_Keys_Name_Select_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_select_next_event = /** @type {((inputs?: Shortcut_Keys_Name_Select_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Select_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner l'evenement suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächstes Ereignis auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona evento successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите следующее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar próximo evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择下一个活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベントを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगला कार्यक्रम चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o próximo evento")
	return /** @type {LocalizedString} */ ("Select Next Event")
});